export enum InputWidthTypes {
    Maximum = "maximum-width",
    Large = "large-width",
    Middle = "middle-width",
    Small = "small-width",
    Smallest = "smallest-width",
    Inherit = "inherit-width"
}
